import React, { useEffect, useState } from "react";
import Report from "../HomeScreenHeader/Reports/Report";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { postAPICall } from "../Api/Api";
import { useLoader } from "../GlobalComponents/Loader";
export default function AssetLog() {
  const [assetDataSource, setAssetDataSource] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [TotalAssetCount, setTotalAssetCount] = useState(0);
      const { showLoader, hideLoader } = useLoader();
  
  const calculateRowsPerPage = () => {
    const screenHeight = window.innerHeight;
    const rowHeight = 35; // Approximate height of each row in pixels (you can adjust this)
    const headerHeight = 100; // Estimated height for header, paginator, etc.

    const availableHeight = screenHeight - headerHeight;
    const calculatedRows = Math.floor(availableHeight / rowHeight);

    setRowsPerPage(calculatedRows);
  };
  useEffect(() => {
    GetAssetLogData();
    calculateRowsPerPage();
    window.addEventListener("resize", calculateRowsPerPage);
    return () => {
      window.removeEventListener("resize", calculateRowsPerPage);
    };
  }, []);
  const GetAssetLogData = async () => {
    showLoader()
    const requestBody = {
      AccountGroupCode: localStorage.getItem("AccountGroupCode"),
    };

    let response = await postAPICall("api/DGTReports/AssetLog", requestBody);
    debugger;
    if (response?.data) {
      setAssetDataSource(response?.data);
      setTotalAssetCount(response?.data?.length);
    }
    hideLoader()
  };
  return (
    <div>
      <Report />
      <DataTable
        paginator
        rows={rowsPerPage}
        value={assetDataSource}
        scrollable
        scrollHeight="83vh"
        style={{ width: "auto" }}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column
          field="Name"
          header="Name"
          sortable
          style={{ width: "30%" }}
          footer={`Total Asset Log:  ${TotalAssetCount}`}
        />
        <Column field="RegisterDate" header="Register Date" sortable />
        <Column field="LastSyncDate" header="last Sync date" sortable />
        <Column field="DaysDifference" header="Days difference" sortable />
      </DataTable>
    </div>
  );
}
